const cloneDeep = require("lodash.clonedeep");

module.exports = cloneDeep;
